import { defineMessages } from 'react-intl';

export default defineMessages({
  dateOfOrder: {
    id: 'dateOfOrder',
    defaultMessage: 'Date of order',
  },
  dateOfAttendance: {
    id: 'dateOfAttendance',
    defaultMessage: 'Date of attendance',
  },
  apply: {
    id: 'apply',
    defaultMessage: 'Apply',
  },
  today: {
    id: 'today',
    defaultMessage: 'Today',
  },
  tomorrow: {
    id: 'tomorrow',
    defaultMessage: 'Tomorrow',
  },
  yesterday: {
    id: 'yesterday',
    defaultMessage: 'Yesterday',
  },
  past7Days: {
    id: 'past7Days',
    defaultMessage: 'Past 7 days',
  },
  past30Days: {
    id: 'past30Days',
    defaultMessage: 'Past 30 days',
  },
  next7Days: {
    id: 'next7Days',
    defaultMessage: 'Next 7 days',
  },
  next30Days: {
    id: 'next30Days',
    defaultMessage: 'Next 30 days',
  },
  yearToDate: {
    id: 'yearToDate',
    defaultMessage: 'Year to date',
  },
  allDates: {
    id: 'allDates',
    defaultMessage: 'All dates',
  },
  custom: {
    id: 'custom',
    defaultMessage: 'Custom',
  },
  selectTimeslot: {
    id: 'selectTimeslot',
    defaultMessage: 'Select timeslot',
  },
  allDatesAndTimeslots: {
    id: 'allDatesAndTimeslots',
    defaultMessage: 'All dates and timeslots'
  },
  dateRange: {
    id: 'dateRange',
    defaultMessage: 'Date range'
  },
  selectDateRange: {
    id: 'selectDateRange',
    defaultMessage: 'Select date range'
  },
  filterTimeslots: {
    id: 'filterTimeslots',
    defaultMessage: 'Filter timeslots'
  },
  customDateOfAttendance: {
    id: 'customDateOfAttendance',
    defaultMessage: 'Custom date of attendance'
  },
  specificTimeslot: {
    id: 'specificTimeslot',
    defaultMessage: 'Specific timeslot'
  },
  rangeOfTimeslots: {
    id: 'rangeOfTimeslots',
    defaultMessage: 'Range of timeslots'
  },
  allTimeslots: {
    id: 'allTimeslots',
    defaultMessage: 'All timeslots'
  },
  nextTimeslot: {
    id: 'nextTimeslot',
    defaultMessage: 'Next timeslot'
  },
  chooseATimeslot: {
    id: 'chooseATimeslot',
    defaultMessage: 'Choose a timeslot that matches'
  },
  startTime: {
    id: 'startTime',
    defaultMessage: 'Start time'
  },
  duration: {
    id: 'duration',
    defaultMessage: 'Duration'
  },
  intervalMinutesShort: {
    id: 'intervalMinutesShort',
    defaultMessage: 'Mins',
  },
  intervalHoursShort: {
    id: 'intervalHoursShort',
    defaultMessage: 'Hours',
  },
  timeslotsBetween: {
    id: 'timeslotsBetween',
    defaultMessage: 'Timeslots starting between'
  },
  startRange: {
    id: 'startRange',
    defaultMessage: 'Start range'
  },
  endRange: {
    id: 'endRange',
    defaultMessage: 'End range'
  },
  startDate: {
    id: 'startDate',
    defaultMessage: 'Start date'
  },
  endDate: {
    id: 'endDate',
    defaultMessage: 'End date'
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel'
  },
  invalidTimeString: {
    id: 'invalidTimeString',
    defaultMessage: 'Invalid time string. Use the format 00:00 AM/PM (ie. "12:15 PM").'
  },
  invalidDuration: {
    id: 'invalidDuration',
    defaultMessage: 'Invalid duration'
  },
  invalidRange: {
    id: 'invalidRange',
    defaultMessage: 'Invalid timeslot range selected'
  },
  noDuration: {
    id: 'noDuration',
    defaultMessage: 'No duration selected'
  },
  loading: {
    id: 'loading',
    defaultMessage: 'Loading...'
  }
});
